import {useCallback} from 'react';
import css from 'styled-jsx/css';
import {
  getStaticAssetUrl,
  StaticAssetType,
} from '../../../../../../common/shared/utils/getStaticAssetUrl';
import {TEXT_VIEWER_FONT_FAMILY_FILE_NAME} from '../constant';
import {PREVENT_SCROLL_CLASSNAME} from '../constant/talkViewerConstant';
import {useNormalTextViewerCoreOption} from '../hook/useNormalTextViewerCoreOption.hook';
import {TextViewerFontFamilyType} from '../type/TextViewerFontFamilyType.enum';

export function TextViewerGlobalStyleContainer({
  isCmsPreview,
  isPreview,
}: {
  isCmsPreview: boolean;
  isPreview: boolean;
}) {
  const getFontUrl = useCallback(
    (fontName: string) => getStaticAssetUrl(fontName, StaticAssetType.Font),
    []
  );

  const fontStyle = css`
    ${Object.values(TextViewerFontFamilyType).reduce((acc, font) => {
      const fontUrl = getFontUrl(TEXT_VIEWER_FONT_FAMILY_FILE_NAME[font]);
      // WEB_STATIC_HOST에서 폰트를 가져오는 경우 cors에러 등을 대비해 fallback으로 WEB_HOST에서 직접 가져올 수 있게 해 준다.
      const directFontUrl = `/public/font/${font}`;
      acc += `
        @font-face {
          font-family: ${font};
          font-style: normal;
          src: url('public/font/${
            TEXT_VIEWER_FONT_FAMILY_FILE_NAME[font]
          }') format('woff')${
            directFontUrl ? `, url(${directFontUrl}) format('woff')` : ''
          };
        }`;
      return acc;
    }, '')}
  `;

  const {backgroundColor} = useNormalTextViewerCoreOption();

  if (isPreview) {
    return (
      <style jsx global>
        {fontStyle}
      </style>
    );
  }

  return (
    <>
      <style jsx global>
        {`
          html {
            overscroll-behavior-y: none;
          }
          body {
            overscroll-behavior-y: none;
            overflow-x: hidden;
            ${
              backgroundColor &&
              `background-color: ${backgroundColor} !important;`
            }
          }
          body.${PREVENT_SCROLL_CLASSNAME} {
            height: 100%;
            overflow-y: hidden;
          }
          * {
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            -webkit-touch-callout: none;
            user-select: ${isCmsPreview ? 'auto' : 'none'};
            touch-action: pan-y pan-x;
          }
        `}
      </style>
      <style jsx global>
        {fontStyle}
      </style>
    </>
  );
}
